<template>
  <power-wrapper :CurrRole="CurrRole">
    <div class="distributorList">
      <div class="topLeft">
        <h3>成员报表<span class="time">续报人数、续报率、续报金额的数据更新时间为T+1，其余数据均延迟10分钟更新</span></h3>
        <div class="refresh">按照团队维度汇总的完整数据链路，按体验课订单支付时间周期来统计</div>
      </div>
      <div class="topRight">
        <el-select v-model="listQuery.dimension" class="selectWidth" @change="toggleSearch">
          <el-option
            v-for="item in allTime"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          />
        </el-select>
        <el-date-picker
          v-model="createTime"
          value-format="timestamp"
          type="daterange"
          :picker-options="pickerOptions"
          :clearable="false"
          @blur="enableChoose"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width:235px"
          :default-time="['00:00:00', '23:59:59']"
          @change="changeDate"
          ></el-date-picker>
        <div>按体验课订单支付时间统计</div>
      </div>
      <el-form :inline="true" :model="listQuery" label-width="100px">
        <el-form-item label="课程科目" label-width="80px">
          <SubjectCascader :onChange="subjectCascaderChange"/>
        </el-form-item>
        <el-form-item label="推广课程" v-if="!isThirdParty">
          <el-select
            value-key="id"
            v-model="listQuery.course_id"
            multiple
            filterable
            clearable
            placeholder="请选择推广课程"
          >
            <el-option label="全部推广课程" value='all' />
            <el-option
              v-for="item in courseList"
              :key="item.id"
              :label="item.agentCourse.name"
              :value="item.agentCourse.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="推广渠道" v-if="!isThirdParty">
          <el-select
            value-key="id"
            v-model="listQuery.promotion_channel_id"
            multiple
            filterable
            clearable
            placeholder="请选择推广渠道"
            @change="handleChannel"
          >
            <el-option label="全部推广渠道" value='all' />
            <el-option
              v-for="item in channelList"
              :key="item.id"
              :label="item.name"
              :value="item.promotionChannelCode"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="推广位" v-if="!isThirdParty">
          <el-select
            value-key="id"
            v-model="listQuery.promotion_position_id"
            multiple
            filterable
            clearable
            placeholder="请选择推广位"
          >
            <el-option label="全部推广位" value='all' />
            <el-option
              v-for="item in promotionList"
              :key="item.id"
              :label="item.name"
              :value="item.promotionPositionCode"
            />
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="支付金额">
          <el-input v-model="listQuery.pay_amount" type="number" placeholder="输入支付金额" class="orderStyle" />
        </el-form-item> -->
        <el-form-item label="学习进度">
          <el-select v-model="listQuery.study_step" filterable placeholder="请选择学习进度">
            <el-option :key="0" label="全部" value='all' />
            <el-option :key="1" label="首课已开课" value="首课已开课" />
            <el-option :key="2" label="首课未开课" value="首课未开课" />
            <el-option :key="3" label="续报已截止" value="续报已截止" />
            <el-option :key="4" label="续报未截止" value="续报未截止" />
          </el-select>
        </el-form-item>
        <el-form-item label="开课日期" label-width="80px">
          <el-date-picker
          v-model="listQuery.class_open_time"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="学期">
          <el-select
            v-model="listQuery.term_id"
            value-key="id"
            multiple
            filterable
            clearable
            placeholder="请选择学期"
          >
            <el-option label="全部" value='all' />
            <el-option
              v-for="item in termList"
              :key="item.id"
              :label="`${item.id}·${item.name}(${item.description})`"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="归属人" v-if="!isThirdParty">
          <el-select
            value-key="id"
            v-model="listQuery.member_id"
            multiple
            filterable
            clearable
            placeholder="请选择归属人"
          >
            <el-option label="全部归属人" value='all' />
            <el-option
              v-for="item in teamList"
              :key="item.id"
              :label="item.name"
              :value="item.agentCode"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="推广商品" v-if="isThirdParty">
          <el-select
            v-model="listQuery.product_id"
            filterable
            remote
            multiple
            clearable
            reserve-keyword
            placeholder="输入渠道组名称查询"
            :remote-method="queryProduct"
            :loading="selectLoading">
            <el-option
              v-for="item in products"
              :key="item.productId"
              :label="item.name"
              :value="item.productId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="达人ID" v-if="isThirdParty">
          <el-input v-model="listQuery.live_talent_id" placeholder="输入达人ID查询"></el-input>
        </el-form-item>
        <el-form-item label="达人昵称" v-if="isThirdParty">
          <el-select
            v-model="listQuery.live_talent_name"
            filterable
            remote
            clearable
            reserve-keyword
            placeholder="输入达人昵称查询"
            :remote-method="queryAuthorName"
            :loading="selectLoading">
            <el-option
              v-for="name in authorName"
              :key="name"
              :label="name"
              :value="name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道组ID" v-if="isThirdParty">
          <el-select
            v-model="listQuery.channel_group_id"
            filterable
            remote
            multiple
            clearable
            reserve-keyword
            placeholder="输入渠道组ID查询"
            :remote-method="query => queryChannel(query, true)"
            :loading="selectLoading">
            <el-option
              v-for="item in channelGroups"
              :key="item.channelGroupId"
              :label="`${item.channelGroupId}${item.channelGroupName}`"
              :value="item.channelGroupId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="子渠道ID" v-if="isThirdParty">
          <el-select
            v-model="listQuery.channel_id"
            filterable
            remote
            multiple
            clearable
            reserve-keyword
            placeholder="输入子渠道ID查询"
            :remote-method="queryChannel"
            :loading="selectLoading">
            <el-option
              v-for="item in channels"
              :key="item.id"
              :label="`${item.id}${item.description}`"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="三方平台" v-if="isThirdParty">
          <el-select v-model="listQuery.shop_platform" filterable placeholder="请选择三方平台">
            <el-option label="全部" value='' />
            <el-option v-for="item in platforms" :key="item.code" :label="item.name" :value='item.code' />
          </el-select>
        </el-form-item>
        <el-button class="filter-item" type="primary" @click="handleSearch">查询</el-button>
      </el-form>
      <!-- 数据折线图 -->
      <div class="all_con">
        <div class="l_con">
          <funcBlock tit="数据折线图" :showBorder=true :isChartShow="isChartShow">
            <mesCon
              slot="blockCon"
              type='timeOrgTerm'
              @get-message-data='getTopFive'
              :dateData="dateData"
              :leftSeriesData="leftSeriesData"
              :rightSeriesData="rightSeriesData"
              :selectChannels="selectChannels"
              :chartParam="chartParam"
              :legendDataArr="selectChannels.length > 1 ? legendDataArr : [legendDataArr[0]]"
              :isChartShow="isChartShow"
              @showLineChart="updateShow"
            >
            </mesCon>
          </funcBlock>
        </div>
      </div>
      <funcBlock tit="详细数据" :showBorder=false>
        <div slot="blockCon">
          <i slot="blockTit" class="blockTit">
            <!-- 下载组件 -->
            <DownExcel
              :listQuery="listQuery"
              :createTime="createTime"
              :total="total"
              pageType="staffOrg"
            />
          </i>
          <!-- // 动态生成表格 -->
          <el-table
            v-loading="listLoading"
            :data="dataList"
            border
            fit
            highlight-current-row
            style="width: 100%, margin-top:100px"
            :header-cell-style="tableHeader"
            :row-class-name="tableColumn"
            @sort-change="changeTableSort"
            :default-sort = "{prop: 'dimension', order: 'ascending'}"
          >
            <el-table-column v-if="listQuery.dimension !== 'sum'" label="日期" prop="dimension" align="center" min-width="180" fixed sortable='custom'>
              <template slot-scope="{row}">
                <span v-if="row.data_cnt" class="special-weight">
                  {{ `总计 ${total ? numberFormat(total) : total } 条记录` }}
                </span>
                <span v-else>{{ row.dimension ? row.dimension : '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="isThirdParty" label="达人ID" prop="live_talent_id" align="center" min-width="140" fixed>
              <template slot-scope="{row}">
                <span>{{ row.live_talent_id }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="isThirdParty" label="达人昵称" prop="live_talent_name" align="center" min-width="140" fixed>
              <template slot-scope="{row}">
                <span>{{ row.live_talent_name }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="!isThirdParty" label="成员" prop="member_id" align="center" min-width="140" fixed>
              <template slot-scope="{row}">
                <span v-if="listQuery.dimension === 'sum' && row.data_cnt" class="special-weight">
                  {{ `总计 ${total ? numberFormat(total) : total } 条记录` }}
                </span>
                <span v-else-if="row.data_cnt" class="special-weight">
                  {{ row.member_name || '--' }}
                </span>
                <span v-else>{{ row.member_name || '无归属人' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="体验课支付人数" prop="sum_l1_num" align="center" min-width="150" fixed sortable='custom'>
              <template slot="header">
                <el-tooltip class="item" effect="dark" content="仅包含已支付人数，剔除已退费人数" placement="top">
                  <span class="icon-question">体验课支付人数</span>
                </el-tooltip>
              </template>
              <template slot-scope="{row}">
                <span v-if="row.data_cnt" class="special-weight">
                  {{ row.sum_l1_num ? numberFormat(row.sum_l1_num) : '--' }}
                </span>
                <span v-else>{{ row.sum_l1_num ? numberFormat(row.sum_l1_num) : '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-for="column in tableColumns"
              :key="column.prop"
              :prop="column.prop"
              :label="column.label"
              :show-overflow-tooltip="true"
              align="center"
              min-width="170"
              sortable='custom'
            >
              <template slot="header"
                v-if="column.label && (column.label.includes('率')
                  || column.label === '全部课完课人数'
                  || column.label === '续报人数'
                  || column.label === '续报金额'
                  || column.label === '续报截止占比'
                  || column.label === '重购人数'
                  || column.label === '重购续报数'
                  || column.label === '重购续报率'
                )"
              >
                <el-tooltip class="item" effect="dark" :content="handlePrompt(column.label)" placement="top">
                  <span class="icon-question">{{ column.label }}</span>
                </el-tooltip>
              </template>
              <template slot-scope="{row}">
                <span v-if="row.data_cnt" class="special-weight">
                  {{ row[column.prop] && row[column.prop] !== '-' ?
                    numberFormatNew(row[column.prop], column.label)
                    : column.label.includes('数') ? 0 : column.label.includes('金额') ? '0.00'
                    : column.label.includes('率') ? '0.00%' : '--'
                  }}
                </span>
                <span v-else>
                  {{ row[column.prop] ? numberFormatNew(row[column.prop], column.label)
                    : column.label.includes('数') ? 0 : column.label.includes('金额') ? '0.00'
                    : column.label.includes('率') ? '0.00%' : '--'
                  }}
                </span>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            v-show="total>=1"
            :total="total"
            :page.sync="listQuery.index"
            :limit.sync="listQuery.pageSize"
            @pagination="getList"
          />
        </div>
      </funcBlock>
    </div>
  </power-wrapper>
</template>

<script>
import Cookie from 'js-cookie';
import Pagination from "@/components/Pagination/index";
import DownExcel from "@/components/DownExcel/index";
import { getCourseList, queryChannelGroup, queryChannel, getThirdPlatforms } from "@/services/order";
import { getTeamList } from "@/services/link";
import { getPromotionList } from "@/services/promotion";
import { getTableTitleNew, getTableTitleSum, getOrgTableNum, getOrgTableAcc, getOrgTable, getChannelList, queryProduct, queryAuthorName } from "@/services/time";
import { getTermListNew } from "@/services/term";
import PowerWrapper from "@/components/PowerWrapper";
import funcBlock from '@/components/chart/funcBlock'
import mesCon from '@/components/chart/index/mesCon'
import SubjectCascader from "@/components/SubjectCascader";
import { timestampToDate, timestampToDateTotal, delUndefined, numFormat, formatNumberRgx2, deteleObject } from "@/utils/utils";
import { getTeamCode, getAgentCode, getTeamRole, isThirdParty } from '@/utils/auth'
import { initOptions, initColumns, handlePrompt } from '@/utils/constant'

export default {
  name: "org",
  components: {
    Pagination,
    PowerWrapper,
    funcBlock,
    mesCon,
    DownExcel,
    SubjectCascader
  },
  data() {
    return {
      CurrRole: "timeOrg",
      dataList: [],
      listQuery: {
        index: 1,
        pageSize: 10,
        subject_type: '',
        class_open_time: '',
        dimension: 'day',
        course_id: null, // 推广课程
        study_step: null, // 学习进度
        term_id: null, // 学期
        promotion_position_id: null, // 推广位
        member_id: (Number(getTeamRole()) === 1 || Number(getTeamRole()) === 2) ? null : getAgentCode(), // 归属人
        promotion_channel_id: null, // 推广渠道ids,多个逗号分割
        orderColumn: 'dimension',
        orderType: 'asc',
        pay_amount: null,
        product_id: [],
        live_talent_name: '',
        channel_group_id: [],
        channel_id: [],
        shop_platform: ''
      },
      createTime: [new Date(new Date().setHours(0, 0, 0, 0)).getTime() - 3600 * 1000 * 24 * 30, new Date(new Date().setHours(23, 59, 59, 0)).getTime()],
      pickerMinDate: "", // 第一次选中的时间
      pickerOptions: {
        shortcuts: [
          {
            text: "今日",
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().setHours(0, 0, 0, 0));
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "昨日",
            onClick(picker) {
              const start = new Date();
              start.setTime(start.getTime() - 24 * 60 * 60 * 1000);
              start.setHours(0, 0, 0, 0);
              const end = new Date();
              end.setTime(end.getTime() - 24 * 60 * 60 * 1000);
              end.setHours(23, 59, 59, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              const end = new Date();
              const week = end.getDay();
              const millisecond = 1000 * 60 * 60 * 24;
              const minusDay = week !== 0 ? week - 1 : 6;
              const monday = new Date(end.getTime() - minusDay * millisecond);
              const start = new Date(monday);
              start.setHours(0, 0, 0, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上周",
            onClick(picker) {
              // 上周开始时间
              const starta = new Date();
              var first = starta.getDate() - starta.getDay() - 6;
              var startDate = new Date(starta.setDate(first));
              const start = new Date(startDate);
              start.setHours(0, 0, 0, 0);
              //  上周结束时间
              var currentDate = new Date();
              var firsts = currentDate.getDate() - currentDate.getDay() - 6;
              var last = firsts + 6;
              var endDate = new Date(currentDate.setDate(last));
              const end = new Date(endDate);
              end.setHours(23, 59, 59, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本月",
            onClick(picker) {
              const currentDate = new Date();
              const currentMonth = currentDate.getMonth();
              const currentYear = currentDate.getFullYear();
              const start = new Date(currentYear, currentMonth, 1);
              const end = new Date();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上月",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              const m = start.getMonth() - 1;
              start.setDate(1);
              start.setMonth(m);
              end.setDate(0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        onPick: obj => {
          this.pickerMinDate = new Date(obj.minDate).getTime();
        },
        disabledDate: time => {
          if (this.pickerMinDate) {
            const day1 = 93 * 24 * 3600 * 1000;
            const maxTime = this.pickerMinDate + day1;
            const minTime = this.pickerMinDate - day1;
            return time.getTime() > maxTime || time.getTime() < minTime;
          }
        }
      },
      total: 1,
      allTime: [
        {
          value: 'day',
          name: '分日'
        },
        {
          value: 'week',
          name: '分周'
        },
        {
          value: 'month',
          name: '分月'
        },
        {
          value: 'sum',
          name: '累计'
        }
      ],
      listLoading: false,
      statisticsArr: [],
      updateTime: null,
      dateData: [],
      leftSeriesData: [],
      rightSeriesData: [],
      isChartShow: true,
      downloadParam: {},
      dataAcc: {}, // 总计
      flagOrder: null,
      chartList: [],
      courseList: [],
      channelList: [],
      promotionList: [],
      teamList: [],
      tableColumns: [],
      selectChannels: [],
      chartParam: {
        leftValue: 'user_cnt',
        rightValue: 'channel_renewal_cnt'
      },
      legendDataArr: ['体验课支付人数', '续报人数'],
      termList: [], // 学期array
      memberIds: [], // 存放top FIVE member_id
      chartLoading: null,
      isThirdParty: isThirdParty(),
      channelGroups: [],
      channels: [],
      products: [],
      authorName: [],
      platforms: [],
      selectLoading: false,
    };
  },
  computed: {
    tableHeader() {
      return () => {
        return { 'background-color': '#f5f5f5' }
      }
    }
  },
  created() {
    // 获取table表头
    this.getTableTitle()
    // 图表数据
    this.getTopFive()
    // table
    this.getList()
    // 获取推广课程
    this.getCourseList()
    // 获取推广渠道
    this.getChannelList()
    // 获取团队成员信息
    this.getTeamList()
    // 获取学期列表
    this.getTermList()
    // 获取三方平台
    this.getThirdPlatforms()
  },
  methods: {
    async getThirdPlatforms() {
      try {
        const res = await getThirdPlatforms();
        const { errCode, errMsg, data } = res.data;
        if (errCode === 0) {
          this.platforms = data;
        } else {
          this.$message({ type: 'error', message: errMsg })
        }
      } catch (error) {
        this.$message({ type: 'error', message: '三方平台获取失败！请稍后重试' })
      }
    },
    async queryAuthorName(query) {
      if (query) {
        this.selectLoading = true;
        const res = await queryAuthorName(query);
        const { data, errCode } = res.data;
        if (errCode === 0 && data) {
          this.authorName = data;
        } else {
          this.authorName = [];
        }
        this.selectLoading = false;
      } else {
        this.authorName = [];
      }
    },
    async queryProduct(query) {
      if (query) {
        this.selectLoading = true;
        const res = await queryProduct(query);
        const { data, errCode } = res.data;
        if (errCode === 0 && data) {
          this.products = data;
        } else {
          this.products = [];
        }
        this.selectLoading = false;
      } else {
        this.products = [];
      }
    },
    async queryChannel(query, isGroup) {
      const queryFn = isGroup ? queryChannelGroup : queryChannel;
      const channelValue = isGroup ? 'channelGroups' : 'channels';
      let arr = [];
      if (query !== '') {
        this.selectLoading = true;
        try {
          const res = await queryFn(query);
          const { data, errCode } = res.data;
          if (errCode === 0 && data) arr = [data];
        } catch (e) {
          console.error('queryChannel error: ', e);
        }
      }
      this.selectLoading = false;
      this[channelValue] = arr;
    },
    subjectCascaderChange(subject_type) {
      this.listQuery.subject_type = subject_type;
    },
    enableChoose() {
      this.pickerMinDate = null
    },
    tableColumn({ row, rowIndex }) {
      return rowIndex === 0 ? 'row-special' : ''
    },
    handleStatus(value) {
      return value ? value === 'UNPAID' ? '未支付' : value === 'PAID' ? '已支付' : value === 'REFUND' ? '已退费' : '' : null
    },
    numberFormat(num) {
      return numFormat(num)
    },
    numberFormatNew(num, label) {
      const end = label ? label.replace(/^(.*[n])*.*(.|n)$/g, "$2") : label
      return end ? end === '率' ? num ? `${formatNumberRgx2(num * 100)} %` : '0%' : end === '数' ? numFormat(num) : end === '额' && label === '续报金额' ? formatNumberRgx2(num) : num : num
    },
    timestampToDateTotal(time) {
      return timestampToDateTotal(time)
    },
    timestampToDate(time) {
      return timestampToDate(time)
    },
    // 获取表头
    async getTableTitle() {
      this.selectChannels = []
      const { dimension } = this.listQuery
      const res = dimension === 'sum' ? await getTableTitleSum(getTeamCode()) : await getTableTitleNew(getTeamCode())
      if (res && res.data && res.data.data && res.data.errCode === 0 && res.data.data.length > 0) {
        const { data } = res.data;
        if (data && data.length > 0) {
          // initColumns:全部列
          this.tableColumns = initColumns.filter(item => data.includes(item.prop))
          this.selectChannels = initOptions.filter(item => data.includes(item.value))
        } else {
          this.tableColumns = []
        }
      } else if (res.data && res.data.errCode === 1016) {
        this.$message({ type: 'error', message: '登录时效已过期，请重新登录' })
        Cookie.remove('staffToken')
        setTimeout(() => {
          this.$router.push({ path: '/login' })
        }, 3000)
      } else {
        this.tableColumns = [];
      }
    },
    // 排序
    changeTableSort(column) {
      this.listQuery.orderColumn = column.prop;
      this.listQuery.orderType = column.order === "ascending" ? 'asc' : column.order === "descending" ? 'desc' : this.flagOrder;
      this.flagOrder = column.order === "ascending" ? 'asc' : 'desc'
      this.getList(null)
    },
    getList(btnName = '') {
      this.listLoading = true;
      const { listQuery, createTime } = this;
      const _listQuery = Object.assign({}, listQuery);
      Object.keys(_listQuery).forEach(key => {
        const query = _listQuery[key];
        if (Array.isArray(query) && query.indexOf('all') > -1) {
          Object.assign(_listQuery, {
            [key]: null
          })
        }
      });
      const { course_id, promotion_channel_id, promotion_position_id, term_id, member_id, study_step, dimension, product_id = [], channel_group_id = [], channel_id = [] } = _listQuery
      const params = {
        ..._listQuery,
        course_id: course_id && course_id.length && course_id.filter(item => item !== 'null').length ? course_id.filter(item => item !== 'null').join(',') : null,
        promotion_channel_id: promotion_channel_id && promotion_channel_id.length && promotion_channel_id.filter(item => item !== 'null').length ? promotion_channel_id.filter(item => item !== 'null').join(',') : null,
        promotion_position_id: promotion_position_id && promotion_position_id.length && promotion_position_id.filter(item => item !== 'null').length ? promotion_position_id.filter(item => item !== 'null').join(',') : null,
        term_id: term_id && term_id.length && term_id.filter(item => item !== 'null').length ? term_id.filter(item => item !== 'null').join(',') : null,
        member_id: member_id && member_id.length && member_id.filter(item => item !== 'null').length ? member_id.filter(item => item !== 'null').join(',') : null,
        is_renewal: study_step ? study_step === '续报未截止' ? 1 : study_step === '续报已截止' ? 0 : null : null,
        is_unlock: study_step ? study_step === '首课未开课' ? 1 : study_step === '首课已开课' ? 0 : null : null,
        start_date: createTime && createTime[0] ? timestampToDate(createTime[0]) : null,
        end_date: createTime && createTime[1] ? timestampToDate(createTime[1]) : null,
        product_id: product_id.join(','),
        channel_group_id: channel_group_id.join(','),
        channel_id: channel_id.join(','),
      }
      // 表头第一条数据
      const resTotal = getOrgTableNum(delUndefined({
        ...delUndefined(params),
        index: 1,
        pageSize: 1,
        dimension: null,
        orderColumn: null,
        orderType: null
      }))
      let resList = []
      if (dimension && dimension === 'sum') { // 累计
        resList = getOrgTableAcc(delUndefined({
          ...delUndefined(params),
          dimension: null
        }))
      } else {
        resList = getOrgTable(delUndefined({
          ...delUndefined(params)
        }))
      }
      Promise.all([resTotal, resList]).then((results) => {
        const resultTotal = results && results.length && results[0] && results[0].data;
        const res = results && results.length && results[1];
        const dataAcc = resultTotal && resultTotal.errCode === 0 && resultTotal.data && resultTotal.data.length > 0
          ? resultTotal.data[0] : [];
        this.updateTime = dataAcc.load_time || null;
        this.dataAcc = dataAcc;
        if (res && res.data && res.data.data && res.data.errCode === 0 && res.data.data.length > 0) {
          this.listLoading = false;
          const { data, total } = res.data;
          const data_cnt = [{
            ...dataAcc,
            data_cnt: total
          }]
          const dataList = deteleObject(data_cnt.concat(data || []));
          this.dataList = dataList && dataList.length > 1 ? dataList : []
          this.total = total
          // this.total = total ? Math.ceil(total + (total / (pageSize - 1)) - 1) : 0;
          if (btnName === 'search') {
            this.listQuery.index = 1;
          }
        } else if (res.data && res.data.errCode === 1016) {
          this.$message({ type: 'error', message: '登录时效已过期，请重新登录' })
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.listLoading = false;
          this.dataList = [];
          this.total = 0;
        }
      })
    },
    // 获取top5的team_id
    getTopFive(param = {}) {
      this.chartLoading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.6)'
      });
      this.chartParam = param
      const { listQuery, createTime } = this;
      const _listQuery = Object.assign({}, listQuery);
      Object.keys(_listQuery).forEach(key => {
        const query = _listQuery[key];
        if (Array.isArray(query) && query.indexOf('all') > -1) {
          Object.assign(_listQuery, {
            [key]: null
          })
        }
      });
      const { course_id, promotion_channel_id, promotion_position_id, term_id, member_id, study_step, dimension, product_id = [], channel_group_id = [], channel_id = [] } = _listQuery
      const params = {
        ..._listQuery,
        course_id: course_id && course_id.length && course_id.filter(item => item !== 'null').length ? course_id.filter(item => item !== 'null').join(',') : null,
        promotion_channel_id: promotion_channel_id && promotion_channel_id.length && promotion_channel_id.filter(item => item !== 'null').length ? promotion_channel_id.filter(item => item !== 'null').join(',') : null,
        promotion_position_id: promotion_position_id && promotion_position_id.length && promotion_position_id.filter(item => item !== 'null').length ? promotion_position_id.filter(item => item !== 'null').join(',') : null,
        term_id: term_id && term_id.length && term_id.filter(item => item !== 'null').length ? term_id.filter(item => item !== 'null').join(',') : null,
        member_id: member_id && member_id.length && member_id.filter(item => item !== 'null').length ? member_id.filter(item => item !== 'null').join(',') : null,
        is_renewal: study_step ? study_step === '续报未截止' ? 1 : study_step === '续报已截止' ? 0 : null : null,
        is_unlock: study_step ? study_step === '首课未开课' ? 1 : study_step === '首课已开课' ? 0 : null : null,
        start_date: createTime && createTime[0] ? timestampToDate(createTime[0]) : null,
        end_date: createTime && createTime[1] ? timestampToDate(createTime[1]) : null,
        product_id: product_id.join(','),
        channel_group_id: channel_group_id.join(','),
        channel_id: channel_id.join(','),
        index: 1,
        pageSize: 5,
        dimension: null
      }
      // 据说chart数据需要先调累计接口查5个team_id
      getOrgTableAcc(delUndefined({
        ...delUndefined(params),
        orderColumn: param.leftValue || 'sum_l1_num', // 默认体验课
        orderType: "desc"
      })).then((res) => {
        if (res && res.data && res.data.data && res.data.errCode === 0 && res.data.data.length > 0) {
          const { data } = res.data;
          // memberIds, 存放top FIVE team_id
          const isLiveTalentId = isThirdParty && dimension === 'sum';
          const memberIds = data && data.length ? data.map(item => isLiveTalentId ? item.live_talent_id : item.member_id) : []
          this.memberIds = memberIds
          // 用tean_id 查询图表数据
          this.initMessageData({
            ...params,
            dimension,
            member_id: !isLiveTalentId && (memberIds && memberIds.length) ? memberIds.join(',') : '',
            live_talent_id: isLiveTalentId && memberIds && memberIds.length ? memberIds.join(',') : '',
            index: 1,
            pageSize: 1000
          })
        } else if (res.data && res.data.errCode === 1016) {
          this.$message({ type: 'error', message: '登录时效已过期，请重新登录' })
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.memberIds = []
          // 清空图表之前的数据
          this.dateData = [];
          this.leftSeriesData = [];
          this.legendDataArr = []
          this.chartLoading.close() // 关闭loading
        }
      })
    },
    // 查询图表数据
    async initMessageData(params) {
      // 据说chart数据需要用累计接口
      const { dimension } = this.listQuery
      const res = dimension === 'sum' ? await getOrgTableAcc(delUndefined({
        ...delUndefined(params),
        orderColumn: 'dimension', // 默认体验课
        orderType: "asc",
        dimension: null
      })) : await getOrgTable(delUndefined({
        ...delUndefined(params),
        orderColumn: 'dimension', // 默认体验课
        orderType: "asc"
      }))
      if (res && res.data && res.data.data && res.data.errCode === 0 && res.data.data.length > 0) {
        const { data } = res.data;
        this.chartList = data
        // 图表数据
        this.getMessageData()
      } else if (res.data && res.data.errCode === 1016) {
        this.$message({ type: 'error', message: '登录时效已过期，请重新登录' })
        Cookie.remove('staffToken')
        setTimeout(() => {
          this.$router.push({ path: '/login' })
        }, 3000)
      } else {
        this.chartList = [];
        // 清空图表之前的数据
        this.dateData = [];
        this.leftSeriesData = [];
        this.legendDataArr = []
      }
      this.chartLoading.close() // 关闭loading
    },
    // 处理图表数据
    getMessageData() {
      // 清空图表之前的数据
      this.legendDataArr = []
      this.dateData = [];
      this.leftSeriesData = [];
      const defaultLObj = this.selectChannels && this.selectChannels.length ? this.selectChannels[0] : {}
      // 筛选条件
      const leftConditon = this.chartParam.leftValue || defaultLObj.value || 'sum_l1_num';
      const lendLeftArr = initOptions.filter(item => item.value === leftConditon)
      this.legendDataArr = [lendLeftArr && lendLeftArr.length ? lendLeftArr[0].name : '体验课支付人数']
      // 处理图表需要的数据
      const new_list = [].concat(this.chartList || []);
      // pay_date
      // this.memberIds,根据teamId遍历返回的数据
      if (this.memberIds.length && new_list.length) {
        const result = this.memberIds.map((ele) => {
          // 存放数值
          const resultData = []
          // 存放名称
          const resultName = []
          new_list.forEach(item => {
            // 横坐标轴的值
            this.dateData.push(item.dimension)
            if (item.member_id === ele) {
              resultData.push({ data: item[leftConditon], date: item.dimension })
              resultName.push(item.member_name || '无归属人')
            }
          })
          return {
            name: resultName.length ? [...new Set(resultName)].filter(Boolean)[0] : '',
            type: 'line',
            data: resultData.length ? [...new Set(resultData)].filter(Boolean) : []
          }
        })
        this.leftSeriesData = result
      } else {
        this.leftSeriesData = []
      }
    },
    getPromotionList(channelCode) {
      const params = {
        teamCode: getTeamCode(),
        channelCode: channelCode
      }
      getPromotionList(delUndefined(params)).then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          this.promotionList = res.data.data;
        } else if (res.data && res.data.errCode === 1016) {
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.promotionList = [];
        }
      });
    },
    getTeamList() {
      const params = {
        teamCode: getTeamCode()
      }
      getTeamList(delUndefined(params)).then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          let teamArr = []
          // 角色身份
          if (Number(getTeamRole()) === 1 || Number(getTeamRole()) === 2) {
            teamArr = [
              {
                agentCode: 0,
                name: '无归属人'
              }
            ]
            this.teamList = teamArr.concat(res.data.data);
          } else {
            teamArr = [
              {
                agentCode: getAgentCode(),
                name: '我的'
              },
              {
                agentCode: 0,
                name: '无归属人'
              }
            ]
            this.teamList = teamArr;
          }
        } else if (res.data && res.data.errCode === 1016) {
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.teamList = [];
        }
      });
    },
    getCourseList() {
      getCourseList().then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          this.courseList = res.data.data.list;
        } else if (res.data && res.data.errCode === 1016) {
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.courseList = [];
        }
      });
    },
    getChannelList() {
      const teamCode = getTeamCode()
      getChannelList(teamCode).then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          this.channelList = res.data.data;
        } else if (res.data && res.data.errCode === 1016) {
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.channelList = [];
        }
      });
    },
    getTermList() {
      getTermListNew().then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          this.termList = res.data.data;
        } else {
          this.termList = [];
        }
      });
    },
    handleChannel(value) {
      this.channelCode = value;
      this.listQuery.promotion_position_id = null;
      if (value && value.length && value.length === 1 && value.length !== 'null') {
        this.getPromotionList(value[0])
      } else {
        this.promotionList = [];
      }
    },
    changeDate(time) {
      this.handleSearch(time, 'date')
    },
    handleSearch(e, type) {
      this.getTableTitle()
      this.getTopFive()
      this.getList('search');
    },
    toggleSearch() {
      this.listQuery.orderColumn = 'dimension';
      this.listQuery.orderType = 'asc';
      this.listQuery.index = 1;
      this.listQuery.pageSize = 10;
      this.getTableTitle()
      this.getTopFive();
      this.getList('search');
    },
    updateShow() {
      this.isChartShow = !this.isChartShow;
    },
    handlePrompt(str) {
      return handlePrompt(str)
    }
  }
};
</script>
<style lang="less" scoped>
@import '../../styles/common.less';
.special-weight{
  font-weight: bold;
  color: #606266
}
.topRight{
  .selectWidth{
    margin-right: 10px;
    width: 100px;
  }
}
.all_con{
  .l_con, .r_con{
    display: inline-block;
    vertical-align: top;
  }
  .l_con{
    width: 100%;
    // margin-right: 2%;
  }
}
.blockTit{
  position: absolute;
  top: 10px;
  right: 20px;
  cursor: pointer;
}
.blockTit:hover{
  text-decoration: underline;
}
.btn{
  float: right;
}
.icon-question{
  cursor: pointer;
}
</style>
